/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Oct 2021
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import styles from './Sensor.module.css';

const Sensor = props => {
  const { sensor, onClickDeleteSensor } = props;
  const { name, externalId } = sensor || {};
  return (
    <div className={styles.container}>
      <span className={styles.binIcon} onClick={() => onClickDeleteSensor(sensor)}>X</span>
      <div className={styles.name}>{name}</div>
      <span className={styles.external}>{externalId}</span>
    </div>
  );
};

export default Sensor;

Sensor.propTypes = {
  sensor: PropTypes.object,
  onClickDeleteSensor: PropTypes.func,
};

Sensor.defaultProps = {
  sensor: {},
  onClickDeleteSensor: () => { },
};
